/**
 * Page for PDF viewer.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */
import { usePdfAvailability } from '@/hooks/usePdfAvailability'
import { PdfFallback } from './PdfFallback'
import './PdfViewPage.css'


interface PdfViewPageProps {
  pdfDoc: string
}


export const PdfViewPage = (props: PdfViewPageProps) => {
  const status = usePdfAvailability(props.pdfDoc)

  return (
    <div className="pdf-view page">
      {status === 'available' && (
        <object data={props.pdfDoc} type="application/pdf" />
      )}
      {status === 'failed' && <PdfFallback pdfDoc={props.pdfDoc} />}
    </div>
  )
}
